var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolitics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#6800A8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.227 4.66504H9.77298V6.93531H10.227V4.66504Z",
    fill: "#7F7774"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1081 4.66504H7.65405V6.93531H8.1081V4.66504Z",
    fill: "#7F7774"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3459 4.66504H11.8919V6.93531H12.3459V4.66504Z",
    fill: "#554F4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6054 4.36216V3.60542C10.6054 3.27103 10.3344 3 10 3C9.66565 3 9.39459 3.27103 9.39459 3.60542V4.36218C9.39459 4.69654 9.66562 4.9676 10 4.9676C10.3344 4.96757 10.6054 4.69652 10.6054 4.36216Z",
    fill: "#3891E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4865 4.36216V3.60542C8.4865 3.27103 8.21544 3 7.88108 3C7.54672 3 7.27567 3.27103 7.27567 3.60542V4.36218C7.27567 4.69654 7.5467 4.9676 7.88108 4.9676C8.21547 4.9676 8.4865 4.69652 8.4865 4.36216Z",
    fill: "#68AEF4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7243 4.36216V3.60542C12.7243 3.27103 12.4533 3 12.1189 3C11.7846 3 11.5135 3.27103 11.5135 3.60542V4.36218C11.5135 4.69654 11.7846 4.9676 12.1189 4.9676C12.4533 4.9676 12.7243 4.69652 12.7243 4.36216Z",
    fill: "#68AEF4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4216 14.9569V16.1677H6.67026V9.0542H12.4216V10.265L10.9081 12.611L12.4216 14.9569Z",
    fill: "#C08577"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3297 9.0542H11.5135V16.1677H13.3297V9.0542Z",
    fill: "#AB5D4A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7243 15.8647L12.1189 16.3188L12.7243 16.7728H13.6324V15.8647H12.7243Z",
    fill: "#D5AEA4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4216 10.2646V14.9566H11.5135L10.9081 12.6106L11.5135 10.2646H12.4216Z",
    fill: "#D5AEA4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5135 10.2646H7.57837V14.9565H11.5135V10.2646Z",
    fill: "#EAD6D2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9081 6.93506L12.7243 9.35668H13.6324V6.93506H10.9081Z",
    fill: "#D5AEA4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7243 6.93506H6.36758V9.35668H12.7243V6.93506Z",
    fill: "#EAD6D2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5406 6.63232V7.54044H13.6324L13.3297 7.08639L13.6324 6.63232H14.5406Z",
    fill: "#AB5D4A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7243 15.8647H6.36758V16.7729H12.7243V15.8647Z",
    fill: "#EAD6D2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6324 6.63232H5.45947V7.54044H13.6324V6.63232Z",
    fill: "#C08577"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7081 17H6.29189C6.16649 17 6.06485 16.8983 6.06485 16.7729C6.06485 16.6476 6.16646 16.5459 6.29189 16.5459H13.7081C13.8335 16.5459 13.9351 16.6475 13.9351 16.7729C13.9351 16.8983 13.8335 17 13.7081 17Z",
    fill: "#AB5D4A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4973 8.67575H7.5027C7.3773 8.67575 7.27567 8.57411 7.27567 8.44871C7.27567 8.32334 7.37727 8.22168 7.5027 8.22168H12.4973C12.6227 8.22168 12.7243 8.32332 12.7243 8.44871C12.7243 8.57409 12.6227 8.67575 12.4973 8.67575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolitics);
export default __webpack_public_path__ + "static/media/politics.5d87df42a0a4830ac308ff8d86e41656.svg";
export { ForwardRef as ReactComponent };